import * as Sentry from '@sentry/browser';
import UserAgent from '../global/UserAgent';
const userAgent = new UserAgent();
Sentry.onLoad(() => {
    const { config, user, video } = window.__INITIAL_STATE__;
    Sentry.init({
        dsn: config.sentry.dsn,
        environment: config.env,
        release: config.sentry.release,
        tracePropagationTargets: [
            'localhost',
            'hihaho.com',
            'hihaho.app',
            'hihaho.dev',
            'hihaho.test',
            /^\//,
        ],
        tracesSampleRate: config.sentry.traces_sample_rate,
        beforeSend(event, hint) {
            if (userAgent.isExplorer || userAgent.isBot()) {
                return null;
            }
            return event;
        },
        debug: config.sentry.debug,
    });
    const email = user ? user.email : 'guest@hihaho.com';
    if (user) {
        Sentry.setContext('user', {
            id: user.id,
            display_name: user.name,
            email,
        });
    }
    Sentry.setTag('hihaho.email', email);
    if (video) {
        Sentry.setContext('video', {
            uuid: video.video_uuid || video.route_key,
            name: video.video_name,
            session_id: video.session_id,
            video_platform: video.video_platform,
        });
        Sentry.setTags({
            'hihaho.video_uuid': video.video_uuid,
            'hihaho.video_name': video.video_name,
            'hihaho.video_platform': video.video_platform,
            'hihaho.session_id': video.session_id,
        });
    }
});
window.logger = Sentry;
